import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../../actions/layoutActions";
import { EditVendorCertification } from "./EditVendorCertification";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../../actions/dataComponentActions";
import { useUpdateProcessRequests } from "../../../../../hooks/useProcessRequest";
import { getDataComponent } from "../../../../../../reducers/dataComponentReducer";
import { convertServerErrorToFormikErrors } from "../../../../../../utils/formValidationUtils";
import propTypes from "../../../../../../constants/propTypes";
import { vendorCertificationDataComponentId } from "../VendorCertificationsContainer";

const EditVendorCertificationContainer = ({
  vendorCertification,
  dataComponent,
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
}) => {
  useUpdateProcessRequests(dataComponent, {
    onSuccess: () => {
      showSnackNotificationAction("Vendor Certification saved successfully.");
      setReload(vendorCertificationDataComponentId, true);
      closeModalDialog();
    },
    onError: error => {
      const convertedError = convertServerErrorToFormikErrors(error);
      showSnackNotificationAction(convertedError.name);
    },
  });

  const handleEditVendorCertification = values => {
    performUpdateRequest(
      vendorCertificationDataComponentId,
      vendorCertification.id,
      values
    );
  };

  return (
    <EditVendorCertification
      vendorCertification={vendorCertification}
      handleEditVendorCertification={handleEditVendorCertification}
      closeModalDialog={closeModalDialog}
    />
  );
};

EditVendorCertificationContainer.propTypes = {
  vendorCertification: propTypes.certification.isRequired,
  dataComponent: propTypes.dataComponent,
  performUpdateRequest: PropTypes.func.isRequired,
  showSnackNotificationAction: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  closeModalDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    dataComponent: getDataComponent(vendorCertificationDataComponentId, state),
  };
};

const mapDispatchToProps = {
  performUpdateRequest,
  showSnackNotificationAction,
  setReload,
  closeModalDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditVendorCertificationContainer);
